<template>
  <v-container class="readme pa-0" fluid>
    <v-row class="text-center">
      <v-col cols="12" class="text-center pa-0" @click="$emit('openDialog')">
        <v-img class="desktop" src="../assets/desktop_20250806.jpg" min-height="100vh" alt="" cover></v-img>

        <v-img class="mobile" src="../assets/mobile_20250806.jpg" min-height="100vh" position="left" alt="" cover style="position: fixed; width: 100%; height: 100%; right: 0;left: 0; filter: blur(30px) brightness(0.5)"></v-img>

        <v-img class="mobile" src="../assets/mobile_20250806.jpg" min-height="100vh" position="left" alt="" contain stlye="background-color: transparent;"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name : 'HelloWorld',

  data : () => ({
    ecosystem      : [
      {
        text : 'vuetify-loader',
        href : 'https://github.com/vuetifyjs/vuetify-loader',
      },
      {
        text : 'github',
        href : 'https://github.com/vuetifyjs/vuetify',
      },
      {
        text : 'awesome-vuetify',
        href : 'https://github.com/vuetifyjs/awesome-vuetify',
      },
    ],
    importantLinks : [
      {
        text : 'Documentation',
        href : 'https://vuetifyjs.com',
      },
      {
        text : 'Chat',
        href : 'https://community.vuetifyjs.com',
      },
      {
        text : 'Made with Vuetify',
        href : 'https://madewithvuejs.com/vuetify',
      },
      {
        text : 'Twitter',
        href : 'https://twitter.com/vuetifyjs',
      },
      {
        text : 'Articles',
        href : 'https://medium.com/vuetify',
      },
    ],
    whatsNext      : [
      {
        text : 'Explore components',
        href : 'https://vuetifyjs.com/components/api-explorer',
      },
      {
        text : 'Select a layout',
        href : 'https://vuetifyjs.com/layout/pre-defined',
      },
      {
        text : 'Frequently Asked Questions',
        href : 'https://vuetifyjs.com/getting-started/frequently-asked-questions',
      },
    ],
  }),
}
</script>

<style lang="less" scoped>
.readme {
  img {
    width: 100%;
  }
}

.desktop {
  @media (max-width: 600px) {
    display: none;
  }
}

.mobile {
  display: none;
  @media (max-width: 600px) {
    display: block;
  }
}
</style>
